const MAX_SIZE = 32767;

const ENTER_KEY = 13;

export { MAX_SIZE, ENTER_KEY };
